import { render, staticRenderFns } from "./V2AddNickName.vue?vue&type=template&id=387ecc2c&scoped=true&"
import script from "./V2AddNickName.vue?vue&type=script&lang=js&"
export * from "./V2AddNickName.vue?vue&type=script&lang=js&"
import style0 from "./V2AddNickName.vue?vue&type=style&index=0&id=387ecc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ecc2c",
  null
  
)

export default component.exports